// extracted by mini-css-extract-plugin
export default {"numericinput":"styles_numericinput__+Pu2p"};